import React from "react"
import { FormattedMessage } from "react-intl"
import Icon from "../../common/icon/icon.component"

type OwnProps = {
  errorMessage: string
}

const ListingErrorMessage = (props: OwnProps) => {
    return (
        <div className={"row ui-has-modules "}>
            <div className={"col-12 mb-0 ui-module"}>
                <div className={"w-100 d-flex align-items-center justify-content-center my-2"}>
                    <Icon value={"exclamation-circle"} className={"mr-4 text-danger"} size={"75px"} />
                    <div className={""}>
                        <p className={"h2 custom-lead text-custom-primary mb-4"}>
                            <FormattedMessage
                                id="listing.error.header_label"
                                defaultMessage="Error displaying the listing"
                            />
                        </p>
                        <p className={"text-center h6 mb-3 text-danger"}>
                            {props.errorMessage}
                        </p>
                    </div>
                </div>
            </div>
        </div>
    )
}

export default ListingErrorMessage


// WEBPACK FOOTER //
// ./src/common/listing/ListingErrorComponent.tsx